export default (function (_ref) {
  var colors = _ref.colors;
  return {
    base: {
      borderRadius: 3,
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, .15)'
    },
    kindSecondary: {
      borderBottomColor: colors.monotone4
    }
  };
});